import { memo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const FavoriteTeamSkeleton = memo((): ReactElement => {
  const { t } = useTranslation();

  return (
    <div
      className={cc([
        'favoriteTeam-skeleton',
        {
          'favoriteTeam-skeleton__wide': isMobile()
        }
      ])}
    >
      <Skeleton.Button
        active
        className={cc([
          'favoriteTeam-skeleton__element',
          {
            'favoriteTeam-skeleton__element__cube': !isMobile()
          }
        ])}
      />
      {!isMobile() && <span>{t('sportsbook.myFavoriteTeam')}</span>}
    </div>
  );
});
